import { Box, Typography, Chip, LinearProgress } from "@mui/material";
import type { SiteData } from "../types";
import { getMaxRounds } from "../engine/gameModes";

interface SeedInfoProps {
  siteData: SiteData;
}

export default function SeedInfo({ siteData }: SeedInfoProps) {
  const maxRounds = getMaxRounds(siteData);
  const { currentRound, current2Seeds } = siteData.bracketsModeSettings;
  const progress = (currentRound / (maxRounds - 1)) * 100;

  if (siteData.gameFinished) return null;

  return (
    <Box id="seed-info" sx={{ mb: 3 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Round {currentRound} of {maxRounds - 1}
        </Typography>
        {current2Seeds.length === 2 && (
          <Chip
            label={`Seed ${current2Seeds[0]} vs Seed ${current2Seeds[1]}`}
            size="small"
            color="primary"
          />
        )}
      </Box>
      <LinearProgress id="seed-progress" variant="determinate" value={progress} sx={{ borderRadius: 1 }} />
      <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
        <Chip
          label={`${siteData.gameType === "SingleE" ? "Single" : "Double"} Elimination`}
          size="small"
          variant="outlined"
        />
        <Chip
          label={`${siteData.bracketSize} Bracket`}
          size="small"
          variant="outlined"
        />
        {siteData.artistSelected && (
          <Chip label={siteData.artistSelected} size="small" variant="outlined" />
        )}
      </Box>
    </Box>
  );
}
